<template>
    <div>
        <el-form :model="AddDateModel" ref="AddDateRef" :rules="AddDateRules" label-width="110px">

            <el-form-item label="指标类型：" prop="type">
                <el-select v-model="AddDateModel.type" @input="change($event)" :disabled="secDis" placeholder="请选择指标类型" @change="typeChange(AddDateModel.type)">
                    <el-option v-for="item in taroptions" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <!-- <el-form-item label="指标编码：" prop="encode">
                <el-input v-model="AddDateModel.encode" placeholder="请填写指标编码"></el-input>
            </el-form-item> -->

            <el-form-item label="指标名称：" prop="nameval" v-if="listTit!=='附加职责' && listTit!=='基本指标'">
                <el-input @input="change($event)" v-model="AddDateModel.nameval" placeholder="请填写指标名称"></el-input>
            </el-form-item>

            <el-form-item label="指标名称：" prop="name" v-if="listTit=='基本指标'" :rules="{
      required: true, message: '请选择指标名称', trigger: 'change'
    }">
                <el-input maxlength="250" v-model="AddDateModel.name" placeholder="请填写指标名称"></el-input>
                <!-- <el-select v-model="AddDateModel.name" placeholder="请选择项目名称" @change="nameChange(AddDateModel.name)">
                    <el-option v-for="item in nameoptions" :key="item.dictCode" :label="item.dictLabel" :value="item.dictLabel">
                    </el-option>
                </el-select> -->
            </el-form-item>

            <el-form-item label="指标分类：" prop="addres" v-if="listTit=='附加职责'" :rules="{
      required: true, message: '请选择指标分类', trigger: 'change'
    }">
                <el-select disabled v-model="AddDateModel.addres" placeholder="请选择指标分类" @change="addChange(AddDateModel.addres)">
                    <el-option v-for="item in addoptions" :key="item.dictType" :label="item.dictName" :value="item.dictType">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="指标名称：" prop="name" v-if="listTit=='附加职责'" :rules="{
      required: true, message: '请选择指标名称', trigger: 'change'
    }">
                <el-input maxlength="250" v-model="AddDateModel.name" placeholder="请填写指标名称"></el-input>
                <!-- <el-select v-model="AddDateModel.name" placeholder="请选择项目名称" @change="cnameChange(AddDateModel.name)">
                    <el-option v-for="item in addresoptions" :key="item.dictCode" :label="item.dictLabel" :value="item.dictLabel">
                    </el-option>
                </el-select> -->
            </el-form-item>

            <el-form-item label="指标内涵：" prop="connotation">
                <el-input type="textarea" maxlength="250" show-word-limit v-model="AddDateModel.connotation" placeholder="请填写指标内涵"></el-input>
            </el-form-item>

            <el-form-item label="建议分值：" prop="suggscore">
                <el-input v-model="AddDateModel.suggscore" type="number" placeholder="请填写建议分值"></el-input>
            </el-form-item>

            <el-form-item label="特性：" prop="character">
                <el-select v-if="listTit=='单项补助及奖惩指标'" v-model="AddDateModel.character" placeholder="请选择特性" @change="charChange(AddDateModel.character)">
                    <el-option v-for="item in singoptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>

                <el-select v-else v-model="AddDateModel.character" placeholder="请选择特性" @change="charChange(AddDateModel.character)">
                    <el-option v-for="item in chaoptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="单位：" prop="unit">
                <el-select v-model="AddDateModel.unit" placeholder="请选择单位" @change="unitChange(AddDateModel.unit)">
                    <el-option v-for="item in unitoptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <!-- <el-form-item label="分值：" prop="score">
                <el-input type="number" v-model="AddDateModel.score" placeholder="请填写分值"></el-input>
            </el-form-item> -->

            <el-form-item label="指标说明：" prop="remark">
                <el-input type="textarea" maxlength="250" show-word-limit v-model="AddDateModel.remark" placeholder="请填写指标说明"></el-input>
            </el-form-item>

            <el-form-item label="指标状态：" prop="status">
                <el-switch v-model="AddDateModel.status" active-color="#13ce66" inactive-color="#929292" active-value="0" inactive-value="1">
                </el-switch>
            </el-form-item>

            <div class="btnCen">
                <el-button v-if="addDepClick" type="primary" :loading="addDepClickKing" @click="addKeshi">{{diaBtn}}</el-button>
                 <el-button v-else type="info" :loading="addDepClickKing"></el-button>
            </div>

        </el-form>
    </div>
</template>

<script>
import _qs from "qs";
export default {
    props: [
        "diaBtn",
        "EditDateModel",
        "wardId",
        "listTit",
        "dytyTit",
        "dictType",
        "dytyId",
        "secondId",
        "dieId",
        "dicTypeVal",
    ],
    data() {
        var nameValda = async (rule, value, callback) => {
            if (!value && String(value) !== "0") {
                return callback(new Error("请填写指标名称"));
            } else {
                if (this.edValName == value) {
                    callback();
                } else {
                    let type;
                    if (this.listTit == "基本指标") {
                        type = "0";
                    } else if (this.listTit == "工作量指标") {
                        type = "1";
                    } else if (this.listTit == "专项奖励指标") {
                        type = "2";
                    } else if (this.listTit == "单项补助及奖惩指标") {
                        type = "3";
                    } else if (this.listTit == "个人考勤指标") {
                        type = "4";
                    } else if (this.listTit == "附加职责") {
                        type = "5";
                    }
                    let data = _qs.stringify({
                        name: value,
                        type: type, //指标类型（0基础指标 1工作量指标 2专项奖励指标 3单项补助及奖惩指标  4个人考勤指标  5附加职责）
                    });
                    let { data: res } = await this.$axios.checkName(data);
                    // console.log(res);
                    if (res.code == 401) {
                        this.$router.push("/login");
                    } else if (res.code == 200) {
                        callback();
                    } else {
                        return callback(new Error(res.msg));
                    }
                }
            }
        };
        return {
            secDis: false,
            taroptions: [],
            nameoptions: [],
            addoptions: [],
            addresoptions: [],
            addDepClick: true,
            addDepClickKing: false,
            AddDateModel: {
                type: "",
                name: "",
                nameval: "",
                encode: "",
                connotation: "",
                status: "0",
                addres: "",
                remark: "",
                suggscore: "",
                score: "",
                character: "",
                unit: "",
                workloadIndicatorType: "",
            },
            edValName: "",
            chaoptions: [
                {
                    value: "0",
                    label: "系数加分",
                },
                {
                    value: "1",
                    label: "系数减分",
                },
                {
                    value: "2",
                    label: "固定金额",
                },
                {
                    value: "3",
                    label: "评分",
                },
            ],
            singoptions: [
                {
                    value: "0",
                    label: "系数加分",
                },
                {
                    value: "1",
                    label: "系数减分",
                },
                {
                    value: "2",
                    label: "固定金额",
                },
                {
                    value: "3",
                    label: "评分",
                },
                {
                    value: "4",
                    label: "百分比减分",
                },
            ],
            workoptions: [
                {
                    value: "0",
                    label: "病例病种赋分",
                },
                {
                    value: "1",
                    label: "医疗服务项目",
                },
            ],
            unitoptions: [
                {
                    value: "0",
                    label: "次",
                },
                {
                    value: "1",
                    label: "人/次",
                },
                {
                    value: "2",
                    label: "半天/次",
                },
            ],
            AddDateRules: {
                nameval: {
                    required: true,
                    validator: nameValda,
                    trigger: "blur",
                },
                unit: [
                    {
                        required: true,
                        message: "请选择单位",
                        trigger: "change",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请选择指标类型",
                        trigger: "change",
                    },
                ],
                // addres: [
                //     {
                //         required: true,
                //         message: "请选择附加职责",
                //         trigger: "change",
                //     },
                // ],
                score: [
                    {
                        required: true,
                        message: "请输入分值",
                        trigger: "blur",
                    },
                ],
                // name: [
                //     {
                //         required: true,
                //         message: "请输入指标名称",
                //         trigger: "blur",
                //     },
                // ],
                encode: [
                    {
                        required: true,
                        message: "请输入指标编码",
                        trigger: "blur",
                    },
                ],
                connotation: [
                    {
                        required: true,
                        message: "请填写指标内涵",
                        trigger: "blur",
                    },
                ],
                // remark: [
                //     {
                //         required: true,
                //         message: "请填写指标说明",
                //         trigger: "blur",
                //     },
                // ],
                // suggscore: [
                //     {
                //         required: true,
                //         message: "请填写建议分值",
                //         trigger: "blur",
                //     },
                // ],
                character: [
                    {
                        required: true,
                        message: "请选择特性",
                        trigger: "change",
                    },
                ],
                workloadIndicatorType: [
                    {
                        required: true,
                        message: "请选择工作量指标类型",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    watch: {
        EditDateModel: {
            handler(newVal, oldVal) {
                this.echo();
            },
            deep: true,
        },
    },
    created() {
        this.echo();
        // 指标分类
        this.optionselect();
    },
    methods: {
        dicTypeChange() {
            if (this.dicTypeVal) {
                this.AddDateModel.addres = this.dicTypeVal;
            }
        },
        async perdindBy() {
            let data = {
                status: "0",
                deleteFlag: "0", //删除标识（0正常  1已删除）
                name: "",
                indicatorLibraryType: this.dieId, //指标类型（0基本指标 1工作量指标 2专项奖励指标 3单项补助及奖惩指标  4个人考勤指标  5附加职责）
                id: "",
            };
            let res = await this.$axios.perdindBy(data);
            // console.log(res);
            if (res.status == "200") {
                this.taroptions = res.data;
                // console.log(res.data);
                if (this.listTit == "单项补助及奖惩指标") {
                    this.secDis = false;
                } else if (this.listTit == "基本指标") {
                    this.secDis = true;
                    this.AddDateModel.type = this.secondId;
                } else {
                    this.secDis = true;
                    this.tarId = res.data[0].id;
                    this.AddDateModel.type = res.data[0].id;
                }
            }
        },
        typeChange(val) {
            this.AddDateModel.type = val;
        },
        change(e) {
            this.$forceUpdate();
        },
        async sysDictType() {
            let data = {
                dictType: this.dictType,
                status: "0",
                dictName: this.dytyTit,
            };

            let res = await this.$axios.findBySys(data);
            // console.log(res);
            if (res.status == 200) {
                this.nameoptions = res.data;
            }
        },
        async optionselect() {
            let data = {
                dataType: "1",
            };

            let { data: res } = await this.$axios.optionselect(data);
            // console.log(res);
            if (res.code == 200) {
                this.addoptions = res.data;
            }
        },
        nameChange(val) {
            this.AddDateModel.name = val;
        },
        addChange(val) {
            // console.log(val);
            this.AddDateModel.addres = val;
            // this.findBySys(val);
        },
        async findBySys(val) {
            let data = _qs.stringify({
                dictType: val,
                status: "0",
                indicatorLibraryType: "5", //指标类型（0基础指标 1工作量指标 2专项奖励指标 3单项补助及奖惩指标  4个人考勤指标  5附加职责）
            });
            let { data: res } = await this.$axios.sysDictData(data);
            // console.log(res);
            if (res.code == 401) {
                this.$router.push("/login");
            } else if (res.code == 200) {
                this.addresoptions = res.data;
            } else {
                this.$message({
                    message: res.msg,
                    type: "error",
                });
            }
        },
        cnameChange(val) {
            this.AddDateModel.name = val;
        },
        charChange(val) {
            this.AddDateModel.character = val;
        },
        unitChange(val) {
            this.AddDateModel.unit = val;
        },
        worChange(val) {
            this.AddDateModel.workloadIndicatorType = val;
        },
        echo() {
            this.perdindBy();
            if (this.EditDateModel.id) {
                // 指标类型
                this.AddDateModel.type =
                    this.EditDateModel.indicatorSecondLibraryId;

                this.AddDateModel.name = this.EditDateModel.name;
                this.AddDateModel.nameval = this.EditDateModel.name;
                this.edValName = this.EditDateModel.name;
                this.AddDateModel.encode = this.EditDateModel.encoded;
                this.AddDateModel.connotation = this.EditDateModel.intension;
                this.AddDateModel.remark = this.EditDateModel.explain;
                this.AddDateModel.status = this.EditDateModel.status + "";
                this.AddDateModel.suggscore = this.EditDateModel.suggestedScore;
                this.AddDateModel.score = this.EditDateModel.score;
                if (this.EditDateModel.unit !== null) {
                    this.AddDateModel.unit = this.EditDateModel.unit + "";
                }

                if (this.dicTypeVal) {
                    this.AddDateModel.addres = this.dicTypeVal;
                } else {
                    this.AddDateModel.addres = this.EditDateModel.dictTypeName;
                }

                if (this.EditDateModel.dictTypeName) {
                    this.findBySys(this.EditDateModel.dictTypeName);
                }
                if (this.EditDateModel.characteristic !== null) {
                    this.AddDateModel.character =
                        this.EditDateModel.characteristic + "";
                }

                if (this.EditDateModel.workloadIndicatorType == null) {
                    this.AddDateModel.workloadIndicatorType = "";
                } else {
                    this.AddDateModel.workloadIndicatorType =
                        this.EditDateModel.workloadIndicatorType + "";
                }
            }
        },
        addKeshi() {
            if (this.diaBtn == "新增") {
                // 新增
                this.addworkIn();
            } else if (this.diaBtn == "修改") {
                // 修改
                this.updateworkIn();
            }
        },
        clearadd() {
            this.edValName = "";
            this.AddDateModel = {
                name: "",
                nameval: "",
                encode: "",
                connotation: "",
                status: "0",
                addres: "",
                remark: "",
                suggscore: "",
                score: "",
                character: "",
                unit: "",
                workloadIndicatorType: "",
            };
            this.addresoptions = [];

            this.$refs.AddDateRef.resetFields();
            this.$emit("listworkIn");
        },
        addworkIn() {
            this.$refs.AddDateRef.validate(async (valid) => {
                if (valid) {
                    this.addDepClick = false;
                    this.addDepClickKing = true;
                    let pertype, perName, perid;
                    if (this.listTit == "基本指标") {
                        pertype = "0";
                        perName = this.AddDateModel.name;
                        perid = this.secondId;
                    } else if (this.listTit == "工作量指标") {
                        pertype = "1";
                        perName = this.AddDateModel.name;
                        perid = this.tarId;
                    } else if (this.listTit == "专项奖励指标") {
                        pertype = "2";
                        perName = this.AddDateModel.nameval;
                        perid = this.tarId;
                    } else if (this.listTit == "单项补助及奖惩指标") {
                        pertype = "3";
                        perName = this.AddDateModel.nameval;
                        perid = this.AddDateModel.type;
                    } else if (this.listTit == "个人考勤指标") {
                        pertype = "4";
                        perName = this.AddDateModel.nameval;
                        perid = this.tarId;
                    } else if (this.listTit == "附加职责") {
                        pertype = "5";
                        perName = this.AddDateModel.name;
                        perid = this.secondId;
                    }
                    let data = _qs.stringify({
                        indicatorSecondLibraryId: perid, //二级指标id
                        type: pertype, //指标类型（0基础指标 1工作量指标 2专项奖励指标 3单项补助及奖惩指标  4个人考勤指标  5附加职责）
                        encoded: this.AddDateModel.encode, //指标编码
                        name: perName, //指标名称
                        intension: this.AddDateModel.connotation, //指标内涵
                        suggestedScore: this.AddDateModel.suggscore, //建议分值
                        characteristic: this.AddDateModel.character, //指标特性（0加分 1减分 2固定分值  3评分）
                        unit: this.AddDateModel.unit, //单位（0次  1人/次  2半天/次）
                        score: this.AddDateModel.score, //分值
                        explain: this.AddDateModel.remark, //指标说明
                        workloadIndicatorType:
                            this.AddDateModel.workloadIndicatorType, //工作量指标类型（0病例病种赋分   1医疗服务项目）  该项参数在指标类型为工作量类型时为必传
                        status: this.AddDateModel.status, //状态（0启用  1停用）默认0
                    });
                    let { data: res } = await this.$axios.thirdAdd(data);

                    // console.log(res);
                    this.addDepClick = true;
                    this.addDepClickKing = false;
                    if (res.code == 401) {
                        this.$router.push("/login");
                    } else if (res.code == 200) {
                        this.clearadd();
                        this.$message({
                            message: res.msg,
                            type: "success",
                        });
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error",
                        });
                    }
                }
            });
        },
        updateworkIn() {
            this.$refs.AddDateRef.validate(async (valid) => {
                if (!valid) return;
                this.addDepClick = false;
                this.addDepClickKing = true;
                let pertype, perName, perid;
                if (this.listTit == "基本指标") {
                    pertype = "0";
                    perName = this.AddDateModel.name;
                    perid = this.secondId;
                } else if (this.listTit == "工作量指标") {
                    pertype = "1";
                    perName = this.AddDateModel.name;
                    perid = this.tarId;
                } else if (this.listTit == "专项奖励指标") {
                    pertype = "2";
                    perName = this.AddDateModel.nameval;
                    perid = this.tarId;
                } else if (this.listTit == "单项补助及奖惩指标") {
                    pertype = "3";
                    perName = this.AddDateModel.nameval;
                    perid = this.AddDateModel.type;
                } else if (this.listTit == "个人考勤指标") {
                    pertype = "4";
                    perName = this.AddDateModel.nameval;
                    perid = this.tarId;
                } else if (this.listTit == "附加职责") {
                    pertype = "5";
                    perName = this.AddDateModel.name;
                    perid = this.secondId;
                }
                let data = _qs.stringify({
                    id: this.wardId, //指标id
                    indicatorSecondLibraryId: perid, //二级指标id
                    type: pertype, //指标类型（0基础指标 1工作量指标 2专项奖励指标 3单项补助及奖惩指标  4个人考勤指标  5附加职责）
                    encoded: this.AddDateModel.encode, //指标编码
                    name: perName, //指标名称
                    intension: this.AddDateModel.connotation, //指标内涵
                    suggestedScore: this.AddDateModel.suggscore, //建议分值
                    characteristic: this.AddDateModel.character, //指标特性（0加分 1减分）
                    score: this.AddDateModel.score, //分值
                    explain: this.AddDateModel.remark, //指标说明
                    unit: this.AddDateModel.unit, //单位（0次  1人/次  2半天/次）
                    workloadIndicatorType:
                        this.AddDateModel.workloadIndicatorType, //工作量指标类型（0病例病种赋分   1医疗服务项目）  该项参数在指标类型为工作量类型时为必传
                    status: this.AddDateModel.status, //状态（0启用  1停用）默认0
                });
                let { data: res } = await this.$axios.threUpdate(data);
                // console.log(res);
                this.addDepClick = true;
                this.addDepClickKing = false;
                if (res.code == 401) {
                    this.$router.push("/login");
                } else if (res.code == 200) {
                    this.clearadd();
                    this.$message({
                        message: res.msg,
                        type: "success",
                    });
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.btnCen {
    text-align: center;
    .el-button {
        width: 150px;
    }
}

.el-textarea {
    width: 300px;
}
</style>
